import React from 'react';
import styled from 'styled-components';

import RetentionCustomSequencePicker from '../../../containers/retention/complex/RetentionCustomSequencePicker';
import RetentionExecutionOptionsBar from '../../../containers/retention/complex/RetentionExecutionOptionsBar';
import RetentionComposeEventSection from './RetentionComposeEventSection';
import RetentionFilter from '../../../containers/retention/complex/RetentionFilter';

const StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  outline: 1px solid #ccc;
  padding: 20px;
  margin-bottom: 24px;

  .retention-compose-event-selection-container {
    display: flex;
  }

  .event-section {
    display: flex;
    flex-direction: column;
    margin-right: 24px;
    min-width: 390px;
  }
`;

const RetentionComposeContainer = (props) => {
  const {
    onFirstEventChange,
    onReturnEventChange,
    events,
    firstEvent,
    returnEvent,
    getEventMetainf,
  } = props;

  return (
    <StyledDiv>
      <div className="retention-compose-event-selection-container">
        <div className="event-section">
          <RetentionComposeEventSection
            onEventChange={(event) => onFirstEventChange(event, getEventMetainf(event))}
            events={events}
            event={firstEvent}
            label="First event"
          />
          <div>
            <RetentionFilter event={firstEvent} eventIndex={0} />
          </div>
        </div>
        <div className="event-section">
          <RetentionComposeEventSection
            onEventChange={(event) => onReturnEventChange(event, getEventMetainf(event))}
            events={events}
            event={returnEvent}
            label="Return event"
          />
          <div>
            <RetentionFilter event={returnEvent} eventIndex={1} />
          </div>
        </div>
        <RetentionCustomSequencePicker />
      </div>
      <RetentionExecutionOptionsBar />
    </StyledDiv>
  );
};

export default RetentionComposeContainer;
